import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "CustomClassifyStatistics" }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { getListData } from '@/service/main/system'
import { useStore } from '@/store'
import dayjs from 'dayjs'
import {initEmptyParam} from "@/hooks/useInitParam";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomClassifyStatistics',
  setup(__props) {

initEmptyParam()
const store = useStore()
const getGroupList = async () => {
  let groupData = await getListData(
    '/main/enterpriseWechat/dingDept/getGroupList',
    {}
  )
  const groupId = searchFormConfig.formItems.find(
    (item) => item.field === 'groupId'
  )
  groupId!.options = groupData.map((item: any) => {
    return { title: item.deptName, value: item.deptId }
  })
}
getGroupList()

const queryParam = {
  timeSlot: [
    dayjs().startOf('date').format('YYYY-MM-DD'),
    dayjs().endOf('date').format('YYYY-MM-DD')
  ]
}
store.commit('system/changeQueyryInfo', queryParam)
const resetCb = () => {
  return queryParam
}

const [
  pageContentRef,
  handleResetClick,
  handleSearchClick,
  handleDownBtnClick
] = usePageSearch(resetCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "customClassifyStatistics",
      downFilename: "客户分类统计.xlsx",
      onDownBtnClick: _unref(handleDownBtnClick)
    }, null, 8, ["contentTableConfig", "onDownBtnClick"])
  ]))
}
}

})